<template>
  <v-form ref="btnForm">
    <v-card class="dialog_card">
      <v-card-title class="card_title pa-2" :style="{ width: dialogWidth }">
        <div class="ml-3">{{ dialogTitle }}</div>
        <div class="close_dialog material-icons" @click="cancel">clear</div>
      </v-card-title>
      <v-card-text class="dialog_content">
        <v-row>
          <v-col cols="auto" v-if="detailData.uuid">
            <!-- :label="
                detailData.status_uuid
                  ? $t('label_To_enable_the')
                  : $t('label_disable')
              " -->
            <mrc_ess_switch
              color="primary"
              :readonly="onlyShow"
              v-model="detailData.status_uuid"
              true-value="1"
              false-value="0"
            ></mrc_ess_switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex" cols="12" sm="12">
            <!-- 类型 -->
            <mrc_ess_dictName
              v-model="detailData.button_type"
              :disabled="onlyShow"
              :placeholder="$t('label_type')"
              :label="$t('label_type') + '*'"
              :errMsg="$errors('detailData', 'button_type', requiredRule)"
              :select_arr="btnType"
            ></mrc_ess_dictName>
          </v-col>
          <!-- 功能 -->
          <v-col class="d-flex" cols="12" sm="12">
            <mrc_ess_dictName
              v-model="detailData.button_category_uuid"
              :disabled="onlyShow"
              :label="$t('label_function') + '*'"
              :placeholder="$t('label_function')"
              :errMsg="$errors('detailData', 'button_category_uuid', requiredRule)"
              :select_arr="btnFunc"
            ></mrc_ess_dictName>
          </v-col>
          <!-- 按钮名称 -->
          <v-col cols="12" sm="12" class="d-flex">
            <mrc_ess_multiText
              required
              style="width: 100%"
              :label="$t('label_The_name_of_the_button') + '*'"
              :readonly="onlyShow"
              :isNational="judegNational('button_name')"
              v-model="detailData.button_name"
              append-icon="mdi-longitude"
              :error-messages="$errors('detailData', 'button_name', requiredRule)"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <!-- 标题 -->
            <mrc_ess_multiText
              required
              style="width: 100%"
              :label="$t('label_The_title') + '*'"
              :isNational="judegNational('button_title')"
              :readonly="onlyShow"
              v-model="detailData.button_title"
              :error-messages="$errors('detailData', 'button_title', requiredRule)"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <!-- 后端接口地址 -->
            <!--  :error-messages="
                $errors('detailData', 'button_description', requiredRule)
              " -->
            <mrc_ess_multiText
              required
              style="width: 100%"
              :label="$t('label_backend_interface_address')"
              :isNational="judegNational('api_url')"
              :readonly="onlyShow"
              v-model="detailData.api_url"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <!-- 描述 -->
            <mrc_ess_multiText
              required
              style="width: 100%"
              :label="$t('label_Button_description') + '*'"
              :isNational="judegNational('button_description')"
              :readonly="onlyShow"
              v-model="detailData.button_description"
              :error-messages="$errors('detailData', 'button_description', requiredRule)"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex" v-if="0">
            <v-checkbox
              color="primary"
              :readonly="onlyShow"
              :label="$t('label_Function_entry')"
              v-model="detailData.is_main"
              :true-value="1"
              :false-value="0"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex">
            <v-checkbox
              color="primary"
              :readonly="onlyShow"
              :label="$t('label_send_email')"
              v-model="detailData.is_send_email"
              :true-value="1"
              :false-value="0"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <mrc_ess_input
              :label="$t('label_URL') + (detailData.button_type == '1' ? '*' : '')"
              :readonly="onlyShow"
              v-model="detailData.url"
              :error-messages="$errors('detailData', 'url', requiredRule)"
            >
            </mrc_ess_input>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <mrc_ess_input
              :readonly="onlyShow"
              :label="$t('label_components') + (detailData.button_type == '1' ? '*' : '')"
              v-model="detailData.button_component"
              required
              placeholder=""
              :error-messages="$errors('detailData', 'button_component', requiredRule)"
            ></mrc_ess_input>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12">
            <mrc_ess_prompt
              :select_arr="client_type"
              :label="$t('label_Client_type') + '*'"
              :disabled="onlyShow"
              value_field="value_field"
              view_fields="view_fields"
              str
              v-model="detailData.client_type_uuid"
              :errMsg="$errors('detailData', 'client_type_uuid', requiredRule)"
              multiple
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12" sm="12">
            <!-- required -->
            <!-- 修改的时候新增的可选 -->
            <!-- :obj="function_button_version" -->
            <mrc_ess_prompt
              :select_arr="version_arr"
              :label="$t('label_version') + '*'"
              :disabled="onlyShow"
              :errMsg="$errors('detailData', 'client_type_uuid', requiredRule)"
              v-model="detailData.version_uuid"
            ></mrc_ess_prompt>
            <!-- <v-select
              :items="version_arr"
              v-model="detailData.version_uuid"
              :label="$t('label_version') + '*'"
              v-if="update_add && !detailData.uuid"
              :readonly="onlyShow"
              :rules="[(v) => !!v || $t('label_version')]"
              chips
            ></v-select> -->
            <!-- 修改的时候 之前的按钮  只读版本 -->
            <!-- <v-text-field
              v-if="detailData.uuid"
              v-model="detailData.version_uuid"
              :label="$t('label_version') + '*'"
              readonly
            ></v-text-field> -->
            <!-- 新增的时候版本和功能版本一致 -->
            <!-- <v-text-field
              v-if="!detailData.uuid && !update_add"
              v-model="version_uuid"
              :label="$t('label_version') + '*'"
              readonly
            ></v-text-field> -->
          </v-col>
          <v-col cols="12">
            <mrc_ess_brandupload
              v-model="detailData.button_icon"
              :label="$t('label_Button_icon')"
              :disabled="onlyShow"
              @changeimgSrc="changeimgSrc"
              @deleteicon="deleteicon"
            >
            </mrc_ess_brandupload>
          </v-col>
          <v-col cols="12">
            <!-- <v-text-field
              @blur="verifyNum"
              :label="$t('label_The_sorting') + '*'"
              :readonly="onlyShow"
              v-model="detailData.sequence"
              :rules="
                $text_rules($t('label_The_sorting'), [
                  (v) => /^[1-9]*$/.test(v) || '请输入数字',
                ])
              "
            ></v-text-field> -->
            <mrc_ess_NumInput
              :readonly="onlyShow"
              :error-messages="
                $errors('detailData', 'sequence', between('000-999').concat(requiredRule))
              "
              :label="$t('label_The_sorting') + '*'"
              v-model="detailData.sequence"
            ></mrc_ess_NumInput>
          </v-col>
        </v-row>
      </v-card-text>

      <mrc_ess_submitBtn
        class="py-6"
        v-if="!onlyShow"
        @cancel="cancel"
        @success="success"
        :successText="$t('label_save')"
      ></mrc_ess_submitBtn>
    </v-card>
  </v-form>
</template>

<script>
import { required, between } from 'vuelidate/lib/validators'
export default {
  components: {},

  props: {
    dialogTitle: {
      type: String,
    },
    dialogWidth: {
      type: String,
    },
    client_type: {
      type: Array,
    },
    btnFunc: {
      type: Array,
    },
    btnType: {
      type: Array,
    },
    version_arr: {
      type: Array,
    },
    version_uuid: {
      type: String,
    },
    dialogDefaultData: {
      type: Object,
    },
    onlyShow: {
      type: Boolean,
    },
    update_add: {
      type: Boolean,
    },
    module_uuid: {
      type: String,
    },
  },

  data() {
    return {
      detailData: {
        button_category_uuid: '', //  按钮功用
        client_type_uuid: '', // 客户端类型
        button_type: '', // 按钮类型
        button_name: '', // 按钮名称
        button_description: '', // 按钮描述
        is_main: 0, // 功能入口  1 是 0 否
        status_uuid: '1', // 启用  1 是 0 否
        button_title: '', // 按钮标题
        url: '',
        button_icon: '', // 按钮图标
        sequence: 1, // 排序
        is_send_email: 0, // 发送邮件  1是 0 否
        button_component: '', // component
        version_uuid: '', // 版本
        api_url: '',//后端接口地址
      },
      checkbox: true,
      checkbox1: true,
      uuid: '',
      file: [],
      deleteFileObj: {},
    }
  },
  validations: {
    detailData: {
      button_type: {
        required,
      },
      button_category_uuid: {
        required,
      },
      button_name: {
        required,
      },
      button_title: {
        required,
      },
      button_description: {
        required,
      },
      sequence: {
        required,
        between: between(0, 999),
      },
      url: {
        required(val) {
          if (this.detailData.button_type == '1' && !val) {
            return false
          } else {
            return true
          }
        },
      },
      button_component: {
        required(val) {
          if (this.detailData.button_type == '1' && !val) {
            return false
          } else {
            return true
          }
        },
      },
      client_type_uuid: {
        required,
      },
      version_uuid: {
        required,
      },
    },
  },
  created() { },
  async mounted() {
    await this.national('mrbase_sys_function_buttons')
    this.$nextTick(() => {
      this.dataShow(this.dialogDefaultData)
    })
  },
  methods: {
    deleteicon(v) {
      //要删除的文件
      if (v.uuid) this.deleteFileObj = v
    },
    changeimgSrc(v) {
      //上传的文件
      this.file = v
    },
    // 弹窗数据回显
    dataShow(obj) {
      // 往弹窗传值才做下面的操作
      if (!Object.keys(obj).length) {
        return
      }
      const data = this.$clone(obj)
      obj.button_type = String(obj.button_type)
      // if (data.client_type_uuid) {
      //   data.client_type_uuid = data.client_type_uuid.split(',')
      // }
      this.detailData = data
      this.$refs.btnForm.resetValidation()
    },
    // 关闭dialog 不做修改
    cancel() {
      this.reset()
      this.$emit('cancel')
    },
    reset() {
      this.detailData = {
        button_category_uuid: '', //  按钮功用
        client_type_uuid: '', // 客户端类型
        button_type: '', // 按钮类型
        button_name: '', // 按钮名称
        button_description: '', // 按钮描述
        is_main: 0, // 功能入口  1 是 0 否
        status_uuid: '1', // 启用  1 是 0 否
        button_title: '', // 按钮标题
        url: '',
        button_icon: '', // 按钮图标
        sequence: 1, // 排序
        is_send_email: 0, // 发送邮件  1是 0 否
        button_component: '', // component
        version_uuid: '', // 版本
      }
    },
    // 保存
    success() {
      this.$v.detailData.$touch()
      if (this.$v.detailData.$error) {
        return
      }
      if (this.version_arr.length <= 0) {
        this.detailData.version_uuid = this.version_uuid
      }
      this.detailData.is_main = this.detailData.button_type == 1 ? 1 : 0
      const obj = this.$clone(this.detailData)
      this.$emit('getBtnDetail', obj)
      this.$emit(
        'addBtnIcon',
        { file: this.file, uuid: this.detailData.uuid },
        this.deleteFileObj
      )
      this.reset()
    },
    verifyNum(e) {
      if (!/^[1-9]*$/.test(Number(e.target.value))) {
        this.detailData.sequence = 1
        e.target.value = 1
      }
    },
  },
  computed: {
    function_button_version() {
      return {
        prompt_name: 'function_button_version',
        module_uuid: this.module_uuid,
      }
    },
  },
  watch: {
    dialogDefaultData: {
      handler(val) {
        this.dataShow(val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.dialog_card {
  overflow: hidden;
}
.card_title {
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  color: #fff;
  background-color: #000000;
}
.close_dialog {
  width: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
